module.exports = __webpack_public_path__ + "static/media/SuperShuttle_android_1_preview.e0303027.jpg";